(function () {
  function applyHover(el, on) {
    var spec = el.getAttribute('data-rl-hover');
    if (!spec) return;
    if (!el._rlHoverBase) {
      el._rlHoverBase = {};
      spec.split(';').forEach(function (part) {
        var i = part.indexOf(':');
        if (i < 0) return;
        var prop = part.slice(0, i).trim();
        if (!prop) return;
        el._rlHoverBase[prop] = el.style.getPropertyValue(prop) || '';
      });
    }
    spec.split(';').forEach(function (part) {
      var i = part.indexOf(':');
      if (i < 0) return;
      var prop = part.slice(0, i).trim();
      var val = part.slice(i + 1).trim();
      if (!prop) return;
      if (on) el.style.setProperty(prop, val);
      else el.style.setProperty(prop, el._rlHoverBase[prop] || '');
    });
  }

  document.querySelectorAll('[data-rl-hover]').forEach(function (el) {
    el.addEventListener('mouseenter', function () { applyHover(el, true); });
    el.addEventListener('mouseleave', function () { applyHover(el, false); });
  });

  document.querySelectorAll('[data-rl-focus]').forEach(function (el) {
    var spec = el.getAttribute('data-rl-focus');
    var base = {};
    spec.split(';').forEach(function (part) {
      var i = part.indexOf(':');
      if (i < 0) return;
      var prop = part.slice(0, i).trim();
      base[prop] = el.style.getPropertyValue(prop) || '';
    });
    el.addEventListener('focus', function () {
      spec.split(';').forEach(function (part) {
        var i = part.indexOf(':');
        if (i < 0) return;
        el.style.setProperty(part.slice(0, i).trim(), part.slice(i + 1).trim());
      });
    });
    el.addEventListener('blur', function () {
      Object.keys(base).forEach(function (p) { el.style.setProperty(p, base[p]); });
    });
  });

  var tracks = {
    arrivi: document.getElementById('rl-track-arrivi'),
    preordini: document.getElementById('rl-track-preordini'),
    'in-arrivo': document.getElementById('rl-track-in-arrivo'),
    saldi: document.getElementById('rl-track-saldi')
  };

  function rlTrackStep(track) {
    var card = track.querySelector('.rl-card-product');
    var gap = 16;
    var cardW = card ? card.offsetWidth : 208;
    var perPage = window.matchMedia('(max-width: 989px)').matches ? 2 : 3;
    return (cardW + gap) * perPage;
  }

  function rlScrollTrack(track, dir) {
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var target = Math.max(0, Math.min(max, track.scrollLeft + dir * rlTrackStep(track)));
    track.scrollTo({ left: target, behavior: 'smooth' });
  }

  document.querySelectorAll('[data-rl-scroll]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var track = tracks[btn.getAttribute('data-rl-scroll')];
      if (!track) return;
      var dir = Number(btn.getAttribute('data-dir') || 1);
      rlScrollTrack(track, dir);
    });
  });

  /* Search expand — works with global RL header */
  var header = document.querySelector('.rl-site-header');
  var toggle = document.querySelector('.rl-site-header .rl-search-toggle');
  var input = document.getElementById('rl-site-search-input') || document.getElementById('rl-home-search-input');

  function isDesktopSearch() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function openSearch() {
    if (!header) return;
    header.classList.add('is-search-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', toggle.getAttribute('data-label-close') || 'Close search');
    }
    var delay = isDesktopSearch() ? 280 : 30;
    window.setTimeout(function () {
      if (input) input.focus();
    }, delay);
  }

  function closeSearch() {
    if (!header) return;
    header.classList.remove('is-search-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', toggle.getAttribute('data-label-open') || 'Open search');
    }
    if (input) input.blur();
  }

  function toggleSearch() {
    if (!header) return;
    if (header.classList.contains('is-search-open')) closeSearch();
    else openSearch();
  }

  if (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      toggleSearch();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && header && header.classList.contains('is-search-open')) {
      closeSearch();
    }
  });

  document.addEventListener('click', function (e) {
    if (!header || !header.classList.contains('is-search-open')) return;
    if (header.contains(e.target)) return;
    closeSearch();
  });

  /* Mobile nav / tabs: right-edge fade while there is more to scroll */
  (function initHorizontalScrollHints() {
    var mq = window.matchMedia('(max-width: 989px)');
    var configs = [
      { wrap: '.rl-nav-wrap', track: '.rl-nav' },
      { wrap: '.rl-tabs-wrap', track: '.rl-tabs' }
    ];
    var wraps = [];
    configs.forEach(function (cfg) {
      document.querySelectorAll(cfg.wrap).forEach(function (el) {
        wraps.push({ el: el, trackSel: cfg.track });
      });
    });
    if (!wraps.length) return;

    function update(item) {
      var wrap = item.el;
      var track = wrap.querySelector(item.trackSel);
      if (!track) return;
      if (!mq.matches) {
        wrap.classList.remove('has-overflow', 'is-at-end');
        return;
      }
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 6;
      /* iOS often stops a few px short of max; hide fade before the CTA is covered */
      var atEnd = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 24;
      wrap.classList.toggle('has-overflow', overflow);
      wrap.classList.toggle('is-at-end', atEnd);
    }

    function updateAll() {
      wraps.forEach(update);
    }

    wraps.forEach(function (item) {
      var track = item.el.querySelector(item.trackSel);
      if (!track) return;
      track.addEventListener('scroll', function () { update(item); }, { passive: true });
    });

    window.addEventListener('resize', updateAll, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', updateAll);
    else if (mq.addListener) mq.addListener(updateAll);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateAll).catch(function () { updateAll(); });
    }
    window.setTimeout(updateAll, 50);
    window.setTimeout(updateAll, 300);
  })();

  /* Homepage newsletter: enable CTA only with email + consent */
  document.querySelectorAll('#rl-newsletter-form, .rl-newsletter-form').forEach(function (form) {
    var email = form.querySelector('[data-rl-newsletter-email]');
    var consent = form.querySelector('[data-rl-newsletter-consent]');
    var cta = form.querySelector('[data-rl-newsletter-cta]');
    if (!email || !consent || !cta) return;

    var sync = function () {
      var ready = Boolean(email.value.trim()) && consent.checked;
      cta.disabled = !ready;
      cta.style.opacity = ready ? '1' : '0.45';
      cta.style.cursor = ready ? 'pointer' : 'not-allowed';
    };

    email.addEventListener('input', sync);
    consent.addEventListener('change', sync);
    sync();
  });

  /* Announcement marquee: keep each half at least as wide as the viewport */
  (function setupMarquee() {
    var root = document.querySelector('[data-rl-announcement]');
    if (!root) return;
    var track = root.querySelector('[data-rl-marquee-track]');
    var source = root.querySelector('[data-rl-marquee-source]');
    if (!track || !source) return;

    var template = source.cloneNode(true);
    template.removeAttribute('data-rl-marquee-source');

    var rebuild = function () {
      var target = Math.max(root.clientWidth || 0, window.innerWidth || 0) + 48;
      track.innerHTML = '';

      var guard = 0;
      do {
        track.appendChild(template.cloneNode(true));
        guard += 1;
      } while (track.scrollWidth < target && guard < 20);

      var half = Array.prototype.slice.call(track.children);
      half.forEach(function (node) {
        track.appendChild(node.cloneNode(true));
      });

      /* Constant speed (~42px/s) so longer tracks do not feel rushed */
      var halfWidth = track.scrollWidth / 2;
      var duration = Math.max(70, Math.round(halfWidth / 42));
      track.style.setProperty('--rl-marquee-duration', duration + 's');
      track.style.animation = 'none';
      void track.offsetWidth;
      track.style.animation = '';
    };

    rebuild();
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(rebuild, 150);
    });
  })();

  /* Cart drawer: header icon + card add, without replacing the Redline cart SVG */
  (function setupCartDrawer() {
    var cartPage = (window.routes && window.routes.cart_url) || '/cart';
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    function cartDrawer() {
      return document.querySelector('cart-drawer');
    }

    function openCartDrawer() {
      var drawer = cartDrawer();
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      return false;
    }

    function updateHeaderCount(count) {
      var el = document.querySelector('.rl-header-cart-count');
      if (!el || count == null || isNaN(Number(count))) return;
      var n = Number(count);
      el.textContent = String(n);
      el.classList.toggle('is-empty', n === 0);
    }

    function refreshHeaderCount(cartData) {
      if (cartData && typeof cartData.item_count === 'number') {
        updateHeaderCount(cartData.item_count);
        return;
      }
      fetch(cartPage + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && typeof data.item_count === 'number') updateHeaderCount(data.item_count);
        })
        .catch(function () {});
    }

    document.querySelectorAll('[data-rl-cart-toggle]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!cartDrawer()) return;
        e.preventDefault();
        openCartDrawer();
      });
      link.addEventListener('keydown', function (e) {
        if (!cartDrawer()) return;
        if (e.code === 'Space' || e.key === ' ') {
          e.preventDefault();
          openCartDrawer();
        }
      });
    });

    function addVariant(variantId) {
      var drawer = cartDrawer();
      var id = Number(variantId);
      if (!id) {
        window.location = cartPage;
        return;
      }

      if (!drawer || typeof drawer.renderContents !== 'function') {
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function () {
          window.location = cartPage;
        }).catch(function () {
          window.location = cartPage;
        });
        return;
      }

      var formData = new FormData();
      formData.append('id', String(id));
      formData.append('quantity', '1');
      if (typeof drawer.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          drawer.getSectionsToRender().map(function (section) { return section.id; }).join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            window.location = cartPage;
            return;
          }
          drawer.renderContents(response);
          refreshHeaderCount(response);
        })
        .catch(function () {
          window.location = cartPage;
        });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rl-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      addVariant(btn.getAttribute('data-variant-id'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var btn = e.target.closest('[data-rl-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      addVariant(btn.getAttribute('data-variant-id'));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        refreshHeaderCount(event && event.cartData);
      });
    }
  })();
})();
